import styles from './DialogImageUploader.module.scss'
import {cx} from '../../../../../utils'
import {ReactComponent as UploadCloud} from '../../../../../assets/Icons/UploadCloud.svg'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {IDEATION} from '../../../../../Translation/English/ideation'

interface IDialogImageUploaderProps {
  fileTypes?: string[]
}

export const DialogImageUploader: React.FC<IDialogImageUploaderProps> = ({
  fileTypes: _fileTypes,
}) => {
  const wt = useWt()

  return (
    <div className={styles.dialogImgUploader}>
      <UploadCloud width={20} height={16} />
      <div className={styles.dialogImgUploaderText}>
        {wt(IDEATION.dragPlaceholder)}
      </div>
      <div
        className={cx(
          styles.dialogImgUploaderText,
          styles.dialogImgUploaderBrowse,
        )}
      >
        {wt(IDEATION.browse)}
      </div>
    </div>
  )
}
